// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".savethumburlpop-backdrop[data-v-5ddbe773]{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:2009}.savethumburlpop-content[data-v-5ddbe773]{position:fixed;z-index:2010}\n", ""]);
// Exports
module.exports = exports;
